import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { ShowcaseDelete } from '../../services';
import { ToastResponse } from '../../utilities/ToastResponse';

export const fetchShowcaseDelete = createAsyncThunk(
    'showcaseGet/fetchShowcaseDelete',
    async ({ id }) => {
        const response = await ShowcaseDelete(id)
        ToastResponse(response?.data?.statusCode, response?.data?.message)
        return response.result
    }
);

const showcaseDeleteSlice = createSlice({
    name: 'showcaseDelete',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchShowcaseDelete.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchShowcaseDelete.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchShowcaseDelete.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default showcaseDeleteSlice.reducer;
